import React, { useEffect, useState } from "react";
import { Modal, ScrollArea } from "@mantine/core";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";
import ErrorPage from "../../../common/pages/ErrorPage";
import useSurveyDetailsApiService from "../services/api/SurveyDetailsApiService";
import usePublishSurveyApiService from "../services/api/PublishSurveyApiService";
import SurveyForm from "./SurveyForm";
import PageTabs from "../../../themes/components/PageTabs";
import SurveySummaryPanel from "./SurveySummaryPanel";
import SurveyResponsesPanel from "./SurveyResponsesPanel";
import SurveyDataPanel from "./SurveyDataPanel";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type SurveyReportModelProps = {
  id: number;
};

const SurveyReportModel: React.FC<SurveyReportModelProps> = ({ id }) => {
  const [opened, setOpened] = useState(false);
  // eslint-disable-next-line
  const { isLoading, isError, error, data } = useSurveyDetailsApiService(id);
  const { showToast } = useToasts();

  const {
    // isLoading: isPublishing,
    isError: isPublishError,
    error: publishError,
    isSuccess: isPublishSuccess,
    // mutate: onPublish,
  } = usePublishSurveyApiService();

  useEffect(() => {
    if (isPublishError) {
      showToast({ strapiId: "survey_publish_failed" });
    }
  }, [isPublishError, publishError]);

  useEffect(() => {
    if (isPublishSuccess) {
      showToast({ strapiId: "survey_publish_success" });
    }
  }, [isPublishSuccess]);

  if (isLoading) {
    return <ProgressIndicator />;
  }

  if (isError) {
    return <ErrorPage errors={error} />;
  }

  if (!data) {
    return <div />;
  }

  return (
    <>
      <div style={{ backgroundColor: "#ffffff" }}>
        <PageTabs
          tabs={[
            {
              id: 0,
              name: "Summary",
              content: <SurveySummaryPanel survey={data} />,
            },
            {
              id: 1,
              name: "Responses",
              content: <SurveyResponsesPanel survey={data} />,
            },
            {
              id: 2,
              name: "Data",
              content: <SurveyDataPanel survey={data} />,
            },
          ]}
        />
      </div>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Edit Survey"
        size="xl"
        overlayOpacity={0.1}
        overlayBlur={3}
        centered
      >
        {data && (
          <ScrollArea
            style={{ height: "100%", background: "#f7f7f8" }}
            type="always"
          >
            <SurveyForm values={data} onSuccess={() => setOpened(false)} />
          </ScrollArea>
        )}
      </Modal>
    </>
  );
};

export default SurveyReportModel;
